export const gbp = (pence) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format((pence || 0) / 100);

export const toPence = (s) => {
  const n = Number(String(s ?? "").replace(/[£,\s]/g, ""));
  return Number.isFinite(n) ? Math.round(n * 100) : NaN;
};

export const lineTotal = (lines) =>
  lines.reduce((t, l) => t + Math.round((Number(l.qty) || 0) * toPence(l.unit || 0) * (100 + Number(l.vat || 0)) / 100), 0);

export const STATUS = {
  awaiting_supplier: { label: "Awaiting supplier", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  replied: { label: "Supplier replied", cls: "bg-teal-50 text-teal-800 border-teal-200" },
  escalated: { label: "Escalated", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  resolved: { label: "Resolved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const TYPES = {
  amount_mismatch: "Amount mismatch",
  duplicate_on_statement: "Duplicate on statement",
  missing_invoice: "Invoice not held",
  not_on_statement: "Not on statement",
  credit_missing: "Credit not given",
  credit_amount_mismatch: "Credit short",
  line_total_mismatch: "Lines don't add up",
};

export const ROLE_LABEL = { owner: "Owner", manager: "Manager", staff: "Staff", pending: "Awaiting approval" };

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const today = () => new Date().toLocaleDateString("en-CA");
export const fmtMonth = (m) => (m ? new Date(`${m}-01T12:00:00`).toLocaleDateString("en-GB", { month: "short", year: "numeric" }) : "");

export const refShape = (s) => (s || "").replace(/\s+/g, "").toUpperCase().replace(/[A-Z]/g, "A").replace(/\d/g, "9");
export const describeShape = (sh) => refShape(sh).replace(/A+|9+/g, (m) => ` ${m.length} ${m[0] === "A" ? "letter" : "digit"}${m.length === 1 ? "" : "s"} `).replace(/\s+/g, " ").trim();
export const refProblem = (supplier, ref) => {
  const shapes = (supplier?.inv_shapes || []).map(refShape);
  if (!shapes?.length || !ref?.trim() || shapes.includes(refShape(ref))) return null;
  return `This doesn't look like a ${supplier.name} invoice number (expected ${shapes.map(describeShape).join(" or ")}). Is it the delivery note number? Put that in the delivery note box.`;
};

